
import React, {PropTypes, Component} from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import * as d3 from 'd3';
import { SetModalVisible } from '../../actions';
import AnchoredComponent from '../AnchoredComponent';
import DownloadForm from '../DownloadForm';
import StackedBarChart from '../StackedBarChart';
import ComponentIcons from '../ComponentIcons';
import Modal from '../Modal';
import styles from './NuisanceFlooding.css';
import { DL_SERVICE_URL } from '../../config';
import { simplePlaceName, sameLocationNewHash, downloadImage, round } from '../../utils/utils';
import withStyles from '../../decorators/withStyles';
import { downloadFile, gaEvent, xlt } from "../../utils/utils";
import {SetModalTitle} from "../../actions";
import { pngIcon } from "../../icons";


class NuisanceFlooding extends AnchoredComponent {

  static propTypes = {
    // station: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      dlType: "fairweather-flood-pptx",
      settingsOpen: false,
      downloadOpen: false,
      refs: []
    };

    // TODO: consider making these official props.
    this.margin = {top: 20, right: 20, bottom: 60, left: 75};
    this.width = 780 - this.margin.left - this.margin.right;
    this.height = 340 - this.margin.top - this.margin.bottom;
  }

  openInfo = e => {
    gaEvent('modal', 'open', 'info-fairweather-flood');
    browserHistory.push({pathname: "/about", hash: "#about-coastal-floods",
      state: {modal: true, modalTitle: "About this site", returnTo: location.pathname}}
    );
  };

  openDownload = e => {
    this.closeAll();
    // gaEvent('modal', 'open', 'download-fairweather-flood');
    this.props.dispatch(SetModalVisible(true));
    this.setState({downloadOpen: true})
  };

  closeDownload = e => {
    this.props.dispatch(SetModalVisible(false));
    this.setState({downloadOpen: false});
  };

  closeAll = () => {
    this.props.dispatch(SetModalVisible(false));
    this.setState({downloadOpen: false, settingsOpen: false});
  };

  ssTarget() {
    const { placeType, placeID, waterLevel, forecastType, forecastName, stationNum } = this.props;
    const lang = Transifex.live.getSelectedLanguageCode();
    return `http://riskfinder.climatecentral.org/embed/fairweather-flood-img/${placeType}/${placeID}?level=${waterLevel.level}&unit=${waterLevel.unit}&forecastType=${forecastType}&forecastName=${forecastName}&stationNum=${stationNum}&lang=${lang}`;
  }

  dlCallback = (onDlComplete) => {
    const { placeID } = this.props;
    var url;
    if (this.state.dlType === "fairweather-flood-img") {
      const filename = `surging-seas-fairweather-flood-${placeID}.png`;
      url = DL_SERVICE_URL + "/screenshot" + `?filename=${filename}&width=1024&height=768&url=` + encodeURIComponent(this.ssTarget());
      downloadImage(url, "riskfinder.png", onDlComplete);
    } else if (this.state.dlType === "fairweather-flood-pptx") {
      const filename = `surging-seas-fairweather-flood-${placeID}.pptx`;
      url = DL_SERVICE_URL + "/screenshot" + `?filename=${filename}&format=pptx&width=1024&height=768&url=` + encodeURIComponent(this.ssTarget());
      downloadFile(url, "riskfinder.pptx", onDlComplete);
    }
  };

  setDlType(dlType) {
    if (dlType === "fairweather-flood-img") {
      this.props.dispatch(SetModalTitle("Get image"));
    } else if (dlType === "fairweather-flood-pptx") {
      this.props.dispatch(SetModalTitle("Get slide"));
    }
    this.setState({dlType: dlType});
  }

  handleDownloadClick = (dlType) => {
    gaEvent('modal', 'open', `download-${dlType}`);
    this.setDlType(dlType);
    this.openDownload();
  };

  setTxContent = el => {
    // this.state.refs.push(el);
    d3.select(el).attr("tx-content", "block");
    // d3.select(el).attr("tx-dynamic", "disabled");
  };

  render() {
    const { data, aslrStation, place, placeName, placeContainer } = this.props;
    const station = aslrStation;
    const stnShortName = name => name.split("-")[0].trim();
    const recentDate = data.history.most_recent ? new Date(Date.parse(data.history.most_recent)).toLocaleDateString() : "Not in record";
    const forecastFloodDate = data.history.forecasted_flood ? new Date(Date.parse(data.history.most_recent)) : null;
    const forecastFloodStr = (forecastFloodDate && forecastFloodDate >= new Date()) ? forecastFloodDate.toLocaleString() : "None";
    const simpleState = placeContainer.placeID.split(".")[0];
    const sarState = simpleState === "district-of-columbia" ? "maryland" : simpleState;

    return (
      <div className="NuisanceFlooding main">
        <div className="header">
          <a className="anchor" id="fairweather-floods"/>
          <Link className="hash-link" to={sameLocationNewHash("#fairweather-floods")}>
            <h1>Coastal Floods Are Increasing <span className="anchor-hash">#</span></h1>
          </Link>
          <ComponentIcons hasDownload={false} hasSettings={false} openSettings={this.openSettings} openDownload={() => {this.setDlType("fairweather-flood-pptx"); this.openDownload()}} openInfo={this.openInfo} />
        </div>
        <div className="state-content">
          <div className="graph-title">
            <h5 className="supertitle" ref={this.setTxContent}><var>{xlt(simplePlaceName(placeName).toUpperCase())}</var> AREA*</h5>
            <span>
              <h2>
                Coastal flood days
              <svg className="download-icon png" version="1.1" viewBox="0 0 585.918 585.918" onClick={this.handleDownloadClick.bind(null, "fairweather-flood-img")}>
                {pngIcon}
              </svg>
              </h2>
            </span>
          </div>
          <div>
            <div id="location" className="projection_chart_container">
              <StackedBarChart
                data={data.aslrPoints}
                margin={this.margin}
                width={this.width}
                height={this.height}
                xLabel={"Ten-year Period"}
                yLabel={"Days of Coastal Flooding"}
              >
              </StackedBarChart>
            </div>
            <p className="map-explain" ref={this.setTxContent}>* At <var>{xlt(stnShortName(station.name))}</var> water level station, <var>{station.dist}</var> miles from <var>{xlt(simplePlaceName(placeName))}</var>.
              This is the nearest station analyzed for these statistics. <Link to={{pathname: "/about", hash: "#about-fairweather-flood-proximity", state: {modal: true, modalTitle: "About this site",
                                                                        returnTo: location.pathname}}}>
              <span className="icon question-mark" />
            </Link></p>
            <ul className="aslr-explain">
              <li>Humans are causing climate change, which is causing global sea level to rise.</li>
              <li>This graph shows just how much more flooding has come from this rise,
                  plus the floods that would have taken place anyway.</li>
              <li>Flood definition: water level exceeds a local threshold set by the National Weather Service for "minor" flooding,
                  based on observed impacts such as flooding roads.</li>
              <li>Findings come from a 2016 <a href="http://sealevel.climatecentral.org/uploads/research/Unnatural-Coastal-Floods-2016.pdf"
                                               target="_blank">Climate Central study</a> <a href="http://www.nytimes.com/2016/09/04/science/flooding-of-coast-caused-by-global-warming-has-already-begun.html" target="_blank">covered
                  by the New York Times</a>.</li>
            </ul>
          </div>
          <p>
            The <a href="http://statesatrisk.org/" target="_blank">States at Risk project</a> offers additional resources
            and analysis of <a href={`http://statesatrisk.org/${sarState}/coastal-flooding-impact/`} target="_blank">coastal flood risks for {placeContainer.name}</a>.
          </p>
          {/*<br />*/}
          {/*<div style={{width: "66%"}}>*/}
          {/*<h2 style={{marginBottom: 0}}>The latest numbers</h2>*/}
          {/*<table className="station-stats">*/}
          {/*  <tbody>*/}
          {/*    <tr><td>NWS flood definition </td><td>{(station.nws_minor_mhhw / .3048).toPrecision(2)} ft </td><td>Current water level </td><td>{ data.currWaterLevel.data ? `${parseFloat(data.currWaterLevel.data[0].v).toPrecision(2)} ft` : "Not available"}</td></tr>*/}
          {/*    <tr><td>Flood days {data.history.last_year} total </td><td>{data.history.last_year_count}</td><td>Driven by climate</td><td>{data.history.last_year_count - data.history.last_year_without_aslr}</td></tr>*/}
          {/*    <tr><td>Flood days YTD total </td><td>{data.history.this_year_count}</td><td>Driven by climate</td><td>{data.history.this_year_count - data.history.this_year_without_aslr}</td></tr>*/}
          {/*    <tr><td>Most recent flood day </td><td>{recentDate}</td><td>Driven by climate?</td><td>{recentDate !== "Not in record" ? (data.history.most_recent_height - data.history.current_aslr) >= station.nws_minor_mhhw ? "No" : "Yes" : "N/A"}</td></tr>*/}
          {/*    <tr><td>Flood forecast </td><td>{forecastFloodStr}</td><td></td><td></td></tr>*/}
          {/*  </tbody>*/}
          {/*</table>*/}
          {/*<p className="map-explain" ref={this.setTxContent}>Water levels are relative to average high tide (MHHW).*/}
          {/*Water levels source: <a href={`http://tidesandcurrents.noaa.gov/stationhome.html?id=${station.id}`} target="_blank">NOAA</a>.*/}
          {/*Water level station: <var>{station.name}</var>.*/}
          {/*</p>*/}
          {/*</div>*/}
        </div>
        <Modal
          isOpen={this.state.downloadOpen && this.props.modalVisible}
          handleClick={this.closeDownload}
          containerClass="download"
        >
          <DownloadForm
            id="FairweatherFloodDLForm"
            placeType={place.type}
            placeID={place.id}
            dlType={this.state.dlType}
            productID="fairweather-flood"
            submitted={!this.state.downloadOpen}
            dlCallback={this.dlCallback}
          >
          </DownloadForm>
        </Modal>
      </div>
    );
  }

}

// Use connect solely for access to redux "dispatch";
// Don't use any state from the store. Such props will be passed directly.
export default compose(
  withStyles(styles),
  connect(() => {return {};}),
)(NuisanceFlooding);
